import BlankItem from '@components/blank/BlankItem';
import styled from '@emotion/styled';
import { Fragment, useContext } from 'react';

import useItems from './hooks/useItems';
import Item from './Item';
import ItemSkeletons from './ItemSkeletons';
import ShopItemContext from '../../context/ShopItemContext';

interface Props {
    columns: number;
}

function ItemGrid({ columns }:Props) {
    const { shopId } = useContext(ShopItemContext);
    const { items, isLoading, isBlank } = useItems();
    return (
        <Fragment>
            {isBlank && (<BlankItem/>)}
            <Container columns={columns}>
                {items?.map((item) => (
                    <Item item={item} shopId={shopId} key={item.id} />
                ))}
                {isLoading && (
                    <ItemSkeletons/>
                )}
            </Container>
        </Fragment>
    );
}

const Container = styled.section<{
    columns: number;
}>`
    display: grid;
    padding: var(--spacing-4) var(--spacing-4) var(--spacing-8);
    width: 100%;
    overflow: hidden;
    gap: var(--spacing-6) var(--spacing-4);
    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
`;

export default ItemGrid;
